<template>
  <v-card class="d-flex flex-column align-center justify-center pa-5">
    <div class="d-flex btn-container">
      <v-btn class="ml-auto" text @click="updateShowResponseDialog(false)">
        <v-icon> mdi-close </v-icon>
      </v-btn>
    </div>
    <v-card-title class="mb-5">Προβολή Απάντησης</v-card-title>

    <v-progress-circular
      indeterminate
      color="primary"
      v-if="loader"
    ></v-progress-circular>

    <div v-else class="d-flex flex-column">
      <v-btn color="primary" class="ml-auto mb-4" @click="print"
        ><v-icon> mdi-printer </v-icon></v-btn
      >
      <div v-html="report" id="printMe"></div>
    </div>

    <v-btn
      @click="updateShowResponseDialog(false)"
      class="secondary rounded text-sm-body-1 font-weight-regular mt-16"
      >Επιστροφή</v-btn
    >
  </v-card>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  async created() {
    try {
      this.loader = true;
      console.log(this.currentHcmcReportVersion);

      if (this.$route.path.split("/")[1] == "employees") {
        await this.showResponse(this.currentReportVersion.submittedVersionId);
      } else console.log(this.currentHcmcReportVersion);
      await this.showResponse(this.currentHcmcReportVersion.submittedVersionId);
      //todo?
      this.loader = false;
    } catch {
      this.loader = false;
    }
  },
  data() {
    return {
      loader: false,
    };
  },

  computed: {
    ...mapState({
      currentReportVersion: (state) => state.reports.currentReportVersion,
      currentHcmcReportVersion: (state) =>
        state.hcmcreports.currentHcmcReportVersion,

      currentHcmcReport: (state) => state.hcmcreports.currentHcmcReport,
      currentReport: (state) => state.reports.currentReport,
      report: (state) => state.reports.showResponse,
    }),
  },
  methods: {
    ...mapMutations(["updateShowResponseDialog"]),
    ...mapActions(["showResponse"]),

    async print() {
      await this.$htmlToPaper("printMe");
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-container {
  width: 100%;
}
</style>